// components
import BlockType from "../template-editor/components/block-type/BlockType";
import Addendums from "../addendums/Addendums";
// styles
import styles from "./FillInContent.module.scss";
// utils
import getClasses from "utils/getClasses";
import { getHasChild } from "../template-editor/utils/getHasChild";
import { getIsSectionBlock } from "../template-editor/utils/getIsSectionBlock";
// types
import type { TBlockType } from "../../constants/blockTypeModes";
// contexts
import { BlockTypeContextProvider } from "../template-editor/components/block-type/contexts/BlockTypeContext";

type Props = {
  id?: string;
  uiSchema: UISchema;
  jsonSchema: JSONSchema;
  sectionId?: number;
  parent?: string;
  required?: boolean;
  onChange?: (arg: any) => void;
  isLastChild?: boolean;
  isPrevSection?: boolean;
  isNextSection?: boolean;
  isParentDragging?: boolean;
  formData: any;
  mode: TBlockType;
  disabled?: boolean;
  suicidal?: boolean;
  gptBusy?: boolean;
};

const FillInContent = ({
  id,
  parent,
  required,
  uiSchema = {},
  jsonSchema = { type: "" },
  onChange,
  isLastChild,
  isPrevSection,
  isNextSection,
  formData,
  mode,
  disabled,
  suicidal,
  gptBusy,
}: Props) => {
  const isSection = getIsSectionBlock(jsonSchema, uiSchema);
  const hasChild = getHasChild(uiSchema);

  return (
    <>
      {!id ? null : (
        <div
          className={getClasses(
            styles["fill-in-content"],
            isSection && styles["fill-in-content--is-section"],
            isSection &&
              !hasChild &&
              styles["fill-in-content--section-no-child"],
            isPrevSection && styles["fill-in-content--is-prev-section"],
            isNextSection && styles["fill-in-content--is-next-section"],
            parent && styles["fill-in-content--is-child"],
            parent && isLastChild && styles["fill-in-content--is-child--last"],
          )}
        >
          <BlockTypeContextProvider
            disabled={disabled}
            mode={mode}
            onChange={onChange}
            value={formData}
          >
            <BlockType
              {...{
                id,
                uiSchema,
                jsonSchema,
                parent,
                required,
              }}
              expanded
              suicidal={suicidal}
              gptBusy={gptBusy}
            />
          </BlockTypeContextProvider>
          <Addendums id={id} />
        </div>
      )}

      {/* children */}
      {(uiSchema["ui:order"] || []).map((itemId, index) => {
        const order = uiSchema["ui:order"] || [];
        const prev = order[index - 1];
        const next = order[index + 1];
        const isPrevSection =
          !prev || parent
            ? false
            : getIsSectionBlock(
                jsonSchema?.properties?.[prev],
                uiSchema?.[prev],
              );
        const isNextSection = !next
          ? false
          : getIsSectionBlock(jsonSchema?.properties?.[next], uiSchema?.[prev]);

        const isLastChild = index === (uiSchema["ui:order"] || []).length - 1;
        return (
          <FillInContent
            disabled={disabled}
            mode={mode}
            key={itemId}
            id={itemId}
            parent={id}
            uiSchema={uiSchema[itemId]}
            jsonSchema={(jsonSchema.properties || {})[itemId]}
            isLastChild={isLastChild}
            onChange={(v) =>
              onChange &&
              onChange({
                ...formData,
                [itemId]: v,
              })
            }
            required={!disabled && (jsonSchema.required || []).includes(itemId)}
            formData={formData && formData[itemId]}
            // controls the padding
            isPrevSection={isPrevSection}
            isNextSection={isNextSection}
            suicidal={suicidal}
            gptBusy={gptBusy}
          />
        );
      })}
    </>
  );
};
export default FillInContent;
